<template>
    <div class="app-body">
        <bread-crumb></bread-crumb>
        <el-card class="el-main">
            <el-form :model="form" ref="form" :rules="rules" label-width="145px" label-position="left">
                <el-form-item label="电费项目名称" prop="name" >
                    <el-input v-model="form.name" maxlength="24" style="width:240px" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="关联项目" >
                    <div class="a-flex-rfsc">
                        <le-select-remote-search 
                            style="padding: 0" 
                            v-model="form.incomeIdList" 
                            @input="handleChooseIncome" 
                            multiple 
                            :options="optionsincomeDistri" 
                            :defaultOptions='defaultIncomeInfo'
                            placeholder="请选择（可输入搜索）" />
                    </div>
                </el-form-item>
                <el-form-item label="电费类型" prop="electricFeeType" >
                    <el-select v-model="form.electricFeeType" placeholder="请选择">
                        <el-option v-for="item in electricFeeTypeDic"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="电费缴纳方" prop="chargePayeeType" >
                    <el-select v-model="form.chargePayeeType" placeholder="请选择" clearable @change='chargePayeeTypeChange'>
                        <el-option v-for="item in chargePayeeTypeDic"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="电费价格" prop="unitPrice" >
                    <div class="a-flex-rfsc">
                        <el-input v-model="form.unitPrice" style="width:240px" maxlength="10" @input="form.unitPrice = util.checkMoney5(form.unitPrice)" placeholder="请输入电费价格">
                            <template slot="append">元/kwh</template>
                        </el-input>
                    </div>
                </el-form-item>
                <!-- <el-form-item label="服务费价格" prop="serviceUnitPrice" >
                    <div class="a-flex-rfsc">
                        <el-input v-model="form.serviceUnitPrice" style="width:240px" maxlength="10" @input="form.serviceUnitPrice = util.checkMoney5(form.serviceUnitPrice)" placeholder="请输入服务费价格">
                            <template slot="append">元/kwh</template>
                        </el-input>
                    </div>
                </el-form-item> -->
                <el-form-item label="电费收取方式" prop="chargeFeeType" >
                    <el-select v-model="form.chargeFeeType" placeholder="请选择" clearable @change='chargeFeeTypeChange'>
                        <el-option v-for="item in chargeFeeTypeDic"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="电费收款方" prop="chargePayeeType" >
                    <el-select v-model="form.chargePayeeType" placeholder="请选择" clearable :disabled='form.chargeFeeType == 2' @change='chargePayeeTypeChange'>
                        <el-option v-for="item in chargePayeeTypeDic"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="收款物业方" prop="propertyList" v-if="form.chargePayeeType == 2">
                    <el-button type="primary" size='mini'  @click="addProperty">添加物业</el-button>
                    <div class="a-flex-rfsc a-mb-05" v-for="(item,index) in form.propertyList" :key="index">
                        <le-select-remote-search 
                            style="padding: 0 !important"
                            v-model="item.propertyId" 
                            :options="optionsProperty" 
                            :defaultOptions='defaultPropertyList'
                            placeholder="请选择（可输入搜索）" />
                        <span class="a-mlr-12">，物业占比：</span>
                        <el-input v-model="item.rate" maxlength="24" style="width:120px" placeholder="请输入">
                            <template slot="suffix">%</template>
                        </el-input>
                        <el-tooltip class="devList-btn" effect="dark" content="删除" placement="top">
                            <img src="../../assets/icon/option-del-circle.png" @click="delProperty(index)" class="a-wh-16 a-mlr-12" />
                        </el-tooltip>
                        <!-- <el-tooltip class="devList-btn" effect="dark" content="添加" placement="top" >
                            <img src="../../assets/icon/option-add-circle.png" @click="addProperty" class="a-wh-16 a-mlr-12" />
                        </el-tooltip> -->
                    </div>
                </el-form-item>
                <el-form-item label="默认服务费用" prop='serviceUnitPrice'>
                    <div class="a-flex-rfsc">
                        <jd-input-price v-model="form.serviceUnitPrice" style="width:240px" maxlength="10"></jd-input-price>
                    </div>
                </el-form-item>
                <el-form-item label="账单默认备注" prop="remark">
                    <el-input
                        style="width: 400px;"
                        type="textarea"
                        :autosize="{ minRows: 4 }"
                        placeholder="请输入内容"
                        maxlength="100"
                        show-word-limit
                        v-model="form.remark">
                    </el-input>
                </el-form-item>
                <!-- <el-form-item label="发票规则" prop="chargePayeeType" >
                    <el-select v-model="form.chargePayeeType" placeholder="请选择" clearable @change='chargePayeeTypeChange'>
                        <el-option v-for="item in chargePayeeTypeDic"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <div class="a-fs-14 a-fw-700 a-flex-rfsc" style="margin: 36px 0 16px">
                    <span>关联站点</span>
                </div>
                <div class="a-flex-rfsc">
                    <el-button icon="el-icon-plus" type="primary"  @click="addElectricityMeter">添加电表号</el-button>
                    <el-button icon="el-icon-plus" type="primary"  @click="addStationItem">添加关联站点</el-button>
                </div>
                <el-form-item prop="stationAmmeterList" label-width='0'>
                    <el-table :border='true' :data="form.stationAmmeterList" style="width: 100%;margin-top: 16px">
                        <el-table-column type="index" width="50"></el-table-column>
                        <el-table-column label="站点(可多选)" >
                            <template slot-scope="scope">
                                <!-- <le-select-remote-search 
                                    :multiple='true' 
                                    reserveKeyword 
                                    v-model="row.stationIdList" 
                                    :options="optionsStation" 
                                    :defaultOptions='row.defaultStationList'
                                    placeholder="请选择（可输入搜索）" /> -->
                                <div class="a-flex-cfsfs" style="align-items: stretch;">
                                    <jd-button-remote v-model="scope.row.stationIdList" :options="optionsStation"  :disableOptions='disableStationList' tagKey="electricStation"></jd-button-remote>
                                    <div class="a-flex-rfsfs a-flex-wrap" v-if="scope.row.stationIdList.length">
                                        <div class="send-user a-flex-rfsc" v-for="(item,index) in scope.row.stationIdList" :key="index">
                                            <span class="send-user-tag" v-if="item.status == 1">已转移</span>
                                            <span class="a-c-white">{{ item.label }}</span>
                                            <el-tooltip class="item" effect="dark" content="删除" placement="top">
                                                <i class="el-icon-close a-c-white a-ml-10" @click="handleRemoveStation(scope.$index,index)"></i>
                                            </el-tooltip>

                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <!-- 
                                    :disableOptions='disableStationList' -->
                        <el-table-column label="电表号(可多选)" >
                            <template slot-scope="scope">
                                <!-- <div class="a-flex-cfsfs a-w-100" style="justify-content: flex-start;align-items: flex-start !important">
                                    <le-select-remote-search 
                                    :multiple='true' 
                                    isObj
                                    collapse
                                    reserveKeyword 
                                    requestStart
                                    v-model="scope.row.ammeterIdList" 
                                    :options="optionsAmmeter" 
                                    :defaultOptions='defaultAmmeterAllList.concat(scope.row.defaultAmmeterList)'
                                    placeholder="请选择（可输入搜索）" />
                                    <div class="send-user a-flex-rfsc" v-for="(item,index) in scope.row.ammeterIdList" :key="index">
                                        <span class="a-c-white">{{ item.label }}</span>
                                        <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                                            <i class="el-icon-edit a-c-white a-ml-10" @click="handleEditAmmeter(scope.$index,index)"></i>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark" content="删除" placement="top">
                                            <i class="el-icon-close a-c-white a-ml-10" @click="handleRemoveAmmeter(scope.$index,index)"></i>
                                        </el-tooltip>
                                    </div>
                                </div> -->
                                <div class="a-flex-cfsfs" style="align-items: stretch;">
                                    <jd-button-remote v-model="scope.row.ammeterIdList" :options="optionsAmmeter" :disableOptions='disableAmmeterList'></jd-button-remote>
                                    <div class="a-flex-rfsfs a-flex-wrap" v-if="scope.row.ammeterIdList.length">
                                        <div class="send-user a-flex-rfsc" v-for="(item,index) in scope.row.ammeterIdList" :key="index">
                                            <span class="a-c-white">{{ item.label }}</span>
                                            <!-- <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                                                <i class="el-icon-edit a-c-white a-ml-10" @click="handleEditAmmeter(scope.$index,index)"></i>
                                            </el-tooltip> -->
                                            <el-tooltip class="item" effect="dark" content="删除" placement="top">
                                                <i class="el-icon-close a-c-white a-ml-10" @click="handleRemoveAmmeter(scope.$index,index)"></i>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="电表图片" >
                            <template slot-scope="{ row }">
                                <div class="a-flex-cfsfs a-w-100">
                                    <div class="a-flex-rfsc  a-w-100" v-for="(item, index) in row.ammeterIdList" :key="index">
                                        <span class="block ammeterNo">No.{{ item.name || item.label }}：</span>
                                        <el-image :src="item" :preview-src-list='row.meterPic' style="width: 80px;height:80px;border-radius: 4px;margin-right: 8px"></el-image>
                                    </div>
                                </div>
                            </template>
                        </el-table-column> -->
<!--                         
                                    :disableOptions='disableAmmeterList' -->
                        <el-table-column label="电表设备占比" >
                            <template slot-scope="{ row }">
                                <div class="a-flex-cfsfs a-w-100">
                                    <div class="a-flex-rfsc  a-w-100" v-for="(item, index) in row.ammeterIdList" :key="index">
                                        <span class="block ammeterNo">No.{{ item.name || item.label }}：</span>
                                        <el-input  
                                            style="margin-bottom: 6px"
                                            v-model="item.ratio" 
                                            maxlength="50" 
                                            @input="item.ratio = util.checkMoney(item.ratio)" 
                                            placeholder="请输入" >
                                            <template slot="append">%</template>
                                        </el-input>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="操作" width="100" fixed="right">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="删除" placement="top">
                                    <img src="../../assets/icon/option-del-circle.png" class="a-wh-16" @click="delStationItem(scope.$index)" v-if="form.stationAmmeterList.length > 1" />
                                </el-tooltip>
                                <el-tooltip class="item a-ml-12" effect="dark" content="添加列表" placement="top">
                                    <img src="../../assets/icon/option-add-circle.png" class="a-wh-16" v-if="scope.$index + 1 == form.stationAmmeterList.length" @click="addStationItem" />
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                
                <div style="height: 100px;"></div>
            </el-form>
            <div class="a-line-t-e0 footerBox">
                <el-button type="primary" class="a-ml-24 a-mt-15" @click="submit">立即提交</el-button>
                <el-button class="a-ml-24 a-mt-15" style="margin-left: 24px" @click="cancelSubmit">返回</el-button>
            </div>
        </el-card>
        <electric-ammeter-add ref="ammeterAdd" ></electric-ammeter-add>
    </div>
</template>

<script>
import util from '@/utils/util'
import jdButtonRemote from '../components/formcy/jd-button-remote.vue';
import ElectricAmmeterAdd from './child/electric-ammeter-add.vue';
export default {
  components: { jdButtonRemote, ElectricAmmeterAdd },
    data () {
        var checkPropertyList = async (rule, value, callback) => {
            let errorText = await this.checkRules(this.form.propertyList)
            if(errorText){
                callback(new Error(errorText))
            }else{
                callback()
            }
        };
        var checkStationList = async (rule, value, callback) => {
            let errorText = await this.checkRulesStation(this.form.stationAmmeterList)
            if(errorText){
                callback(new Error(errorText))
            }else{
                callback()
            }
        };
        var checkServiceUnitPrice = (rule, value, callback) => {
            if(value === '0' || (value <= 0 && value !== '')) {
                callback(new Error('若填写默认服务费，则默认服务费须大于0'))
            }else {
                callback()
            }
        };
        
        return {
            util: util,
            id: '',
            editType: '',
            form: {
                name: '',
                electricFeeType: '1',
                chargeFeeType: '',//电费收取方式:1:预充值,2先用后付
                chargePayeeType: '',//电费收款方类型:1:App自交,2物业代收
                unitPrice: '',//电费单价
                serviceUnitPrice: '',//默认服务费
                propertyList: [],
                incomeIdList: [],
                remark: '',//账单默认备注
                stationAmmeterList: [{
                    stationIdList: [],
                    ammeterIdList: [],
                    defaultStationList: [],
                    defaultAmmeterList: [],
                }]
            },
            rules: {
                name: [{required: true, message:'请填写电费项目名称', trigger: 'blur'}],
                electricFeeType: [{required: true, message:'请选择电费类型', trigger: 'change'}],//
                chargeFeeType: [{required: true, message:'请选择电费收取方式', trigger: 'change'}],//电费收取方式:1:预充值,2先用后付
                chargePayeeType: [{required: true, message:'请选择电费收取方', trigger: 'change'}],//电费收款方类型:1:App自交,2物业代收
                unitPrice: [{required: true, message:'请填写电费单价', trigger: 'blur'}],//电费单价
                propertyList: [{ validator: checkPropertyList, trigger: 'change' }],
                stationAmmeterList: [{ validator: checkStationList, trigger: 'change' }],
                serviceUnitPrice: [{ validator: checkServiceUnitPrice, trigger: 'blur' }]
            },
            optionsStation: {
                url: this.$Config.apiUrl.electricStationFilter,
                method: "post",
                params: {
                    incomeIdList: []
                },
                showLoading: false,
                labelKey: "name",
                valueKey: "id",
                searchKey: "queryKey",
                pageSize: 500
            },//站点数据
            optionsAmmeter: {
                url: this.$Config.apiUrl.ammeterFilter,
                method: "post",
                params: {
                    isUsed: 0,
                    eleId: this.$route.query.id ? this.$route.query.id : ''
                },
                showLoading: false,
                labelKey: "name",
                valueKey: "id",
                searchKey: "name",
                pageSize: 500
            },
            optionsProperty: {
                url: this.$Config.apiUrl.propertyCompanyfilter,
                method: "post",
                params: {},
                showLoading: false,
                labelKey: "name",
                valueKey: "id",
                searchKey: "name",
                pageSize: 500
            },
            optionsincomeDistri: {
                url: this.$Config.apiUrl.electricIncomeFilter,
                method: "post",
                params: {
                    bind: 0
                },
                showLoading: false,
                labelKey: "incomeName",
                valueKey: "incomeId",
                searchKey: "name",
                pageSize: 100
            },//项目数据
            defaultIncomeInfo: [],
            defaultPropertyList: [],
            chargeFeeTypeDic: [],
            chargePayeeTypeDic: [],
            disableAmmeterList: [],//不可选择的电表集合
            disableStationList: [],//不可选择的站点集合
            defaultAmmeterAllList: [],//该项目绑定的所有电表集合
            defaultAmmeterAllListReadOnly: [],
            electricFeeTypeDic: []
        }
    },
    watch: {
        'form.stationAmmeterList': {
            deep: true,
            handler (val) {
                let disableAmmeterList = [], disableStationList = []
                this.form.stationAmmeterList.map(item=>{
                    disableStationList = item.stationIdList.concat(disableStationList)
                    disableAmmeterList = item.ammeterIdList.concat(disableAmmeterList)
                })
                this.disableAmmeterList = disableAmmeterList.map(item=>{
                    return item.id || item.value
                })
                this.disableStationList = disableStationList.map(item=>{
                    return item.id || item.value
                })
                // 将所有默认选项中去除掉已被选中的数据 作为默认选项列表
                let defaultAmmeterAllList = this.defaultAmmeterAllListReadOnly.filter(res=>{
                    return this.disableAmmeterList.indexOf(res.id) == -1
                })
                this.defaultAmmeterAllList = defaultAmmeterAllList
            }
        }
    },
    mounted () {
        this.id = this.$route.query.id
        this.editType = this.$route.query.type
        if(this.id) {
            this.getPropertyDetail()
        }
        this.$getDic('chargeFeeType','select').then(res=>{ this.chargeFeeTypeDic = res; })
        this.$getDic('chargePayeeType','select').then(res=>{ this.chargePayeeTypeDic = res; })
        this.$getDic('electricFeeType','select').then(res=>{ this.electricFeeTypeDic = res; })
    },
    methods:{
        // 删除物业收款方
        delProperty (index) {
            this.form.propertyList.splice(index,1)
            this.$refs['form'].validateField(['propertyList'])
        },
        // 删除关联站点列表项
        delStationItem (index) {
            this.form.stationAmmeterList.splice(index,1)
        },
        // 添加站点列表
        addStationItem () {
            this.form.stationAmmeterList.push({
                stationIdList: [],
                ammeterIdList: [],
                defaultStationList: [],
                defaultAmmeterList: [],
            })
        },
        // 添加物业收款方
        addProperty () {
            this.form.propertyList.push({
                propertyId: '',
                rate: ''
            })
        },
        // 编辑电表号
        handleEditAmmeter (index, idx) {
            this.$prompt('请输入电表号', '编辑电表号', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: this.form.stationAmmeterList[index].ammeterIdList[idx].label,
                inputValidator: (val)=>{
                    if(!val){
                        return '请输入电表号'
                    }
                }
            }).then(({ value }) => {
                this.$Axios._post({
                    url: this.$Config.apiUrl.ammeterAdd,
                    params: { 
                        meterNumber: value,
                        meterId: this.form.stationAmmeterList[index].ammeterIdList[idx].value,
                    }
                }).then(res => {
                    if (res.result.code == 0) {
                        this.$message.success('操作成功')
                        this.form.stationAmmeterList[index].ammeterIdList[idx] = {
                            label: value,
                            value: this.form.stationAmmeterList[index].ammeterIdList[idx].value
                        }
                    }
                })
            }).catch(() => {
   
            });
        },
        // 移除电表
        handleRemoveAmmeter (index, idx) {
            this.form.stationAmmeterList[index].ammeterIdList.splice(idx,1)
        },
        handleRemoveStation (index, idx) {
            this.form.stationAmmeterList[index].stationIdList.splice(idx,1)
        },
        // 添加电表号
        addElectricityMeter () {
            this.$refs['ammeterAdd'].dialogVisible = true
            // this.$prompt('请输入电表号', '添加电表号', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     inputValidator: (val)=>{
            //         if(!val){
            //             return '请输入电表号'
            //         }
            //     }
            // }).then(({ value }) => {
            //     this.$Axios._post({
            //         url: this.$Config.apiUrl.ammeterAdd,
            //         params: { 
            //             meterNumber: value
            //         }
            //     }).then(res => {
            //         if (res.result.code == 0) {
            //             this.$message.success('操作成功')
            //         }
            //     })
            // }).catch(() => {
   
            // });
        },
        // 电费收取方式更改
        chargeFeeTypeChange () {
            if(this.form.chargeFeeType == 2) {
                this.form.chargePayeeType = '2'
            }
        },
        // 电费收款方修改
        chargePayeeTypeChange () {
            this.form.propertyList = [{
                propertyId: '',
                rate: 100
            }]
        },
        handleChooseIncome () {
            if(this.form.incomeIdList.length) {
                this.form.stationAmmeterList = [{
                    stationIdList: [],
                    ammeterIdList: [],
                    defaultStationList: [],
                    defaultAmmeterList: [],
                }]
                this.optionsStation.params.incomeIdList = this.form.incomeIdList
            }else {
                this.optionsStation.params.incomeIdList = []
            }
        },
        getPropertyDetail () {
            this.$Axios._post({
                url: this.$Config.apiUrl.electricInfo,
                method: "post",
                params: {
                    id: this.id
                }
            })
            .then(res=>{
                if (res.result.code == 0) {
                    this.form = {
                        ...res.result.data,
                        chargeFeeType: JSON.stringify(res.result.data.chargeFeeType),//电费收取方式:1:预充值,2先用后付
                        chargePayeeType: JSON.stringify(res.result.data.chargePayeeType),//电费收款方类型:1:App自交,2物业代收
                        electricFeeType: JSON.stringify(res.result.data.electricFeeType),
                        unitPrice: res.result.data.unitPrice ? this.$decimal.decimal_except(res.result.data.unitPrice, 100) : '',//电费单价
                        serviceUnitPrice: res.result.data.serviceUnitPrice ? this.$decimal.decimal_except(res.result.data.serviceUnitPrice, 100) : '',//
                        incomeIdList: res.result.data.incomeInfoList.map(item=>{
                                                                            return item.id
                                                                        })
                    }
                    this.defaultIncomeInfo = res.result.data.incomeInfoList.map(item=>{
                        return {
                            incomeId: item.id,
                            incomeName: item.name
                        }
                    })
                    this.form.propertyList = this.form.propertyList.map(item=>{
                        return {
                            ...item,
                            rate: Number((item.rate/100).toFixed(2))
                        }
                    })
                    this.defaultAmmeterAllListReadOnly = this.form.stationAmmeterList.map(item=>{
                        return {
                            id: item.ammeterId,
                            name: item.meterNumber,
                        }
                    })
                    this.defaultAmmeterAllListReadOnly = this.uniqueArr(this.defaultAmmeterAllListReadOnly)
                    let stationGroup = this.groupById(this.form.stationAmmeterList)
                    let arr = Object.values(stationGroup)
                    this.form.stationAmmeterList = arr.map(item=>{
                        let stationIdList = []
                        let ammeterIdList = []
                        let defaultStationList = []
                        let defaultAmmeterList = []
                        item.map(ite=>{
                            stationIdList.push({
                                value: ite.stationId,
                                label: ite.stationName,
                                status: ite.status
                            })
                            ammeterIdList.push({
                                id: ite.ammeterId,
                                name: ite.meterNumber,
                                value: ite.ammeterId,
                                label: ite.meterNumber,
                                ratio: Number((ite.ratio * 100).toFixed(2))
                            })
                            defaultStationList.push({
                                name: ite.stationName,
                                id: ite.stationId
                            })
                            defaultAmmeterList.push({
                                name: ite.meterNumber,
                                id: ite.ammeterId
                            })
                        })
                        return {
                            stationIdList: this.uniqueArr(stationIdList),
                            ammeterIdList: this.uniqueArr(ammeterIdList),
                            defaultStationList: this.uniqueArr(defaultStationList),
                            defaultAmmeterList: this.uniqueArr(defaultAmmeterList)
                        }
                    })
                    if(this.form.chargePayeeType == 2 && (!this.form.propertyList || !this.form.propertyList.length)) {
                        this.form.propertyList = []
                    }
                    
                } else {
                    this.$message.error(res.result.message)
                }
            })
            .catch(err=>{
                console.log(err);
            })
        },
        submit () {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    let reqData = {
                        ...this.form
                    }
                    let reqAmmeterUnique = [] // 所有的电表去重后的数据
                    let originAmmeterUnique = [] // 原始的项目中所有的电表去重后的数据
                    let stationAndAmmeterList = []
                    let confirmText = '是否确认提交？', confirmTitle = '温馨提示'
                    reqData.stationAmmeterList.map((item,index)=>{
                        item.stationIdList.map(ite=>{
                            item.ammeterIdList.map(it=>{
                                reqAmmeterUnique.push(it.id || it.value)
                                stationAndAmmeterList.push({
                                    ammeterId: it.id || it.value,
                                    ratio: it.ratio ? Number((it.ratio * 100).toFixed(0)) : 10000,
                                    stationId: ite.value,
                                    groupId: index+1,//组id，传给后端，标明哪些数据为一组
                                })
                            })
                        })
                    })
                    reqAmmeterUnique = [...new Set(reqAmmeterUnique)]
                    originAmmeterUnique = this.defaultAmmeterAllListReadOnly.map(item=>{
                        return item.id
                    })
                    if(this.hasUniqueElement(originAmmeterUnique, reqAmmeterUnique)) {
                        confirmText = '删除的电表无法再录入电费账单，请确定完成抄表后再删除。'
                        confirmTitle = '本次修改有删除电表，保存修改？'
                    }
                    reqData.propertyList = reqData.propertyList.map(item=>{
                        return {
                            ...item,
                            rate: Number((item.rate*100).toFixed(0))
                        }
                    })
                    this.$confirm(confirmText,confirmTitle)
                    .then(_=>{
                        this.$Axios._post({
                            url: this.$Config.apiUrl.electricEdit,
                            method: "post",
                            params: {
                                ...reqData,
                                unitPrice: this.$decimal.decimal_ride(reqData.unitPrice, 100),
                                serviceUnitPrice: reqData.serviceUnitPrice ? this.$decimal.decimal_ride(reqData.serviceUnitPrice, 100) : '',
                                stationAmmeterList: stationAndAmmeterList
                            }
                        })
                        .then(res=>{
                            if (res.result.code == 0) {
                                this.$message.success('操作成功')
                                this.$router.back()
                                this.$store.dispatch("delView", this.$route);
                            } else {
                                this.$message.error(res.result.message)
                            }
                        })
                        .catch(err=>{

                        })
                    })
                    .catch(_=>{})
                }else{
                    this.$message.error('请检查所填参数是否正确')
                }
            })
        },
        hasUniqueElement(arrA, arrB) {
            return arrA.some(element => !arrB.includes(element));
        },
        cancelSubmit () {
            this.$confirm('是否确认返回？','温馨提示')
            .then(_=>{
                this.$router.back()
                this.$store.dispatch("delView", this.$route);
            })
            .catch(_=>{})
        },
        checkRules (datas) {
            return new Promise((resolve, reject) => {
                if(datas.length && datas){
                    let rateAll = 0
                    let propertyId = []
                    for (let index = 0; index < datas.length; index++) {
                        const item = datas[index];
                        if(!item.propertyId){
                            resolve('请选择物业')
                            return
                        }
                        if(!item.rate || item.rate == 0 || item.rate == '0'){
                            resolve('请填写物业收款占比')
                            return
                        }
                        rateAll += Number(item.rate)
                        propertyId.push(item.propertyId)
                    }
                    if(new Set(propertyId).size !== propertyId.length) {
                        resolve('不可重复选择物业收款方')
                    }else if(rateAll != 100) {
                        resolve('物业收款占比之和必须等于100%')
                    }else {
                        resolve()
                    }
                }else{
                    resolve()
                }
            })
        },
        checkRulesStation (datas) {
            return new Promise((resolve, reject) => {
                if(datas.length && datas){
                    for (let index = 0; index < datas.length; index++) {
                        const item = datas[index];
                        if(!item.stationIdList.length){
                            resolve('请选择站点')
                            return
                        }
                        if(!item.ammeterIdList.length){
                            resolve('请选择电表')
                            return
                        }
                        let ratioAll = 0
                        item.ammeterIdList.map(ite=>{
                            ratioAll += Number(ite.ratio || 100)
                        })
                        if(ratioAll != 100) {
                            resolve('每个电表的设备占比之和必须等于100%')
                            return
                        }
                    }
                    resolve()
                }else{
                    resolve()
                }
            })
        },
        groupById(arr) {
            const result = {};
            arr.forEach(item => {
                if (!result[item.groupId]) {
                result[item.groupId] = [];
                }
                result[item.groupId].push(item);
            });
            return result;
        },
        uniqueArr (arr) {
            return [...new Set(arr.map(t=>JSON.stringify(t)))].map(s=>JSON.parse(s))
        },
    },
}
</script>

<style lang="scss" scoped>
.send-user{
    background: #53A8FF;
    color: #ffffff;
    border-radius: 4px;
    padding: 0 10px;
    margin: 10px 10px 0px 0;
}
.send-user-tag{
    background: #ffffff;
    color: #F56C6C;
    font-size: 10px;
    padding: 0 4px;
    border-radius: 4px;
    margin-right: 6px;
    line-height: 18px;
}
.mt64{
    margin-top: 64px
}
.mt21{
    margin-top: 12px
}
.mr80{
    margin-right: 80px;
}
.c79{
    color: #797979
}
.title{
    width: 150px;
    margin-right: 16px;
}
.content{
    width: 240px
}
.tips{
    font-size: 12px;
    color: #909399;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    line-height: 22px;
}
.ammeterNo{
    white-space: nowrap;
}
/deep/ .el-input-group__prepend{
    height: 32px;
    line-height: 32px;
}
/deep/ .el-input-group__append{
    height: 32px;
    line-height: 32px;
}

/deep/ .el-main .el-card__body::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 10px !important;
    height: 10px !important;
    display: block !important;
}
</style>